var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranscriptLightOrangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9883_420650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13.125C0 12.9592 0.065848 12.8003 0.183058 12.6831C0.300269 12.5658 0.45924 12.5 0.625 12.5H19.375C19.5408 12.5 19.6997 12.5658 19.8169 12.6831C19.9342 12.8003 20 12.9592 20 13.125C20 13.2908 19.9342 13.4497 19.8169 13.5669C19.6997 13.6842 19.5408 13.75 19.375 13.75H0.625C0.45924 13.75 0.300269 13.6842 0.183058 13.5669C0.065848 13.4497 0 13.2908 0 13.125ZM15 0H5C4.33696 0 3.70107 0.263392 3.23223 0.732233C2.76339 1.20107 2.5 1.83696 2.5 2.5V11.25H3.75V2.5C3.75 2.16848 3.8817 1.85054 4.11612 1.61612C4.35054 1.3817 4.66848 1.25 5 1.25H15C15.3315 1.25 15.6495 1.3817 15.8839 1.61612C16.1183 1.85054 16.25 2.16848 16.25 2.5V11.25H17.5V2.5C17.5 1.83696 17.2366 1.20107 16.7678 0.732233C16.2989 0.263392 15.663 0 15 0ZM17.5 15H16.25V17.5C16.25 17.8315 16.1183 18.1495 15.8839 18.3839C15.6495 18.6183 15.3315 18.75 15 18.75H5C4.66848 18.75 4.35054 18.6183 4.11612 18.3839C3.8817 18.1495 3.75 17.8315 3.75 17.5V15H2.5V17.5C2.5 18.163 2.76339 18.7989 3.23223 19.2678C3.70107 19.7366 4.33696 20 5 20H15C15.663 20 16.2989 19.7366 16.7678 19.2678C17.2366 18.7989 17.5 18.163 17.5 17.5V15Z",
    fill: "#FFD9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9883_420650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscriptLightOrangeIcon);
export default __webpack_public_path__ + "static/media/transcript-light-orange-icon.f4dfabbaf1c3482aeecb62c03adf65b4.svg";
export { ForwardRef as ReactComponent };